import { gql } from '@apollo/client'
import { format } from 'date-fns'
import { ethers } from 'ethers'
import { useEffect, useState } from 'react'

import { MOONBEAM } from '../../config/chains'
import { SUBGRAPH_URLS } from '../../config/subgraphs'
import { USD_DECIMALS } from '../const'
import { roundDownToNearestDay } from '../numbers'
import { createClient } from '../useClient'

export default function useTradingStats(params) {
  const [tradingStats, setTradingStats] = useState([])
  const client = createClient(SUBGRAPH_URLS[MOONBEAM].stats)

  useEffect(() => {
    if (!params.fromValue || !params.toValue) {
      return
    }

    const start = roundDownToNearestDay(params.fromValue)
    const end = roundDownToNearestDay(params.toValue)

    const tradingStatsQuery = gql`
      query dailyTradingStats($start: Int!, $end: Int!) {
        tradingStats(
          first: 1000
          orderBy: timestamp
          orderDirection: asc
          where: { period: daily, timestamp_gt: $start, timestamp_lt: $end }
        ) {
          timestamp
          profit
          loss
          profitCumulative
          lossCumulative
          longOpenInterest
          shortOpenInterest
        }
      }
    `

    const getTradingStats = async () => {
      client
        .query({
          query: tradingStatsQuery,
          variables: { start: start, end: end },
        })
        .then(({ data }) => {
          const { tradingStats } = data
          let lastCumulativeProfit = 0
          let lastCumulativeLoss = 0
          const chartData = tradingStats.map((el) => {
            const d = new Date(el.timestamp * 1000)

            const cumulativeProfit = parseFloat(
              ethers.utils.formatUnits(el.profitCumulative, USD_DECIMALS)
            )
            const cumulativeLoss = parseFloat(
              ethers.utils.formatUnits(el.lossCumulative, USD_DECIMALS)
            )
            lastCumulativeProfit =
              cumulativeProfit !== 0 ? cumulativeProfit : lastCumulativeProfit
            lastCumulativeLoss =
              cumulativeLoss !== 0 ? cumulativeLoss : lastCumulativeLoss

            return {
              x: format(d, 'do MMM yyyy'),
              profit: parseFloat(
                ethers.utils.formatUnits(el.profit, USD_DECIMALS)
              ),
              loss: -parseFloat(
                ethers.utils.formatUnits(el.loss, USD_DECIMALS)
              ),
              profitCumulative: lastCumulativeProfit,
              lossCumulative: -lastCumulativeLoss,
              longOpenInterest: parseFloat(
                ethers.utils.formatUnits(el.longOpenInterest, USD_DECIMALS)
              ),
              shortOpenInterest: parseFloat(
                ethers.utils.formatUnits(el.shortOpenInterest, USD_DECIMALS)
              ),
            }
          })

          setTradingStats(chartData)
        })
    }

    getTradingStats()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  return tradingStats
}
